export type TourEventData = {
  destination_point: string;
  date_range: string;
};

export const tour_ga4Event = (tourData: TourEventData) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'tur_configurator',
    destination_point: tourData.destination_point,
    date_range: formatDates(tourData.date_range),
  });
};

function formatDates(dateRange: string): string {
  if (!dateRange) return '';

  const months: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const yearMonthsMap: Map<string, Set<number>> = new Map();

  dateRange.split(',').forEach((date) => {
    const year = date.slice(0, 4);
    const monthIndex = Number(date.slice(4)) - 1;

    if (!yearMonthsMap.has(year)) {
      yearMonthsMap.set(year, new Set());
    }
    yearMonthsMap.get(year)?.add(monthIndex);
  });

  const formattedDates: string[] = [];

  for (const [year, monthSet] of yearMonthsMap) {
    if (monthSet.size === 12) {
      formattedDates.push(`all${year}`);
    } else {
      monthSet.forEach((monthIndex) => {
        formattedDates.push(`${months[monthIndex]}${year}`);
      });
    }
  }

  return formattedDates.join(', ');
}
